module.exports = __webpack_public_path__ + "media/images/admin/dropzone/eye-59d5c8d6449c235a93d6c74743ef4064.svg";